export interface BuildPreviewUrlParams {
  currentSrc: string;
  path: string;
  tenantName: string;
  bucket: string;
  locale: string;
}

export const buildPreviewUrl = ({ currentSrc, path, tenantName, bucket, locale }: BuildPreviewUrlParams): string => {
  const url = new URL(currentSrc);
  url.pathname = path;
  url.searchParams.set('landing', tenantName);
  url.searchParams.set('bucket', bucket);
  url.searchParams.set('locale', locale);
  return url.toString();
};

export const updatePreviewIframe = (newSrc: string): void => {
  const iframe = document.querySelector('.live-preview-window iframe') as HTMLIFrameElement | null;
  if (!iframe?.src) return;
  try {
    const { parentNode, nextSibling } = iframe;
    parentNode?.removeChild(iframe);
    iframe.src = newSrc;
    if (nextSibling) parentNode?.insertBefore(iframe, nextSibling);
    else parentNode?.appendChild(iframe);
  } catch {
    // DOM may have changed externally
  }
};
